<template>
  <v-flex md12>
    <material-card
      color="success"
      title="Unidades Consumidoras"
      text="Unidades Consumidoras pertencentes ao membro"
    >
      <v-layout fluid wrap v-if="filteredQualifications?.length > 0">
        <v-flex sm12 md12 class="mt-2">
          <span class="font-weight-bold"
            >O membro possui as seguintes unidades consumidoras pendentes na
            qualificação:</span
          >
          <div class="mt-2 uc_container">
            <div
              v-for="(qualification, index) in filteredQualifications"
              :key="index"
              :class="{
                uc: true,
                ucSim: qualification.partner_origin === 'SIM',
              }"
            >
              <img
                v-if="qualification.partner_origin == 'SIM'"
                src="../../assets/logo-sim.png"
                alt="logo SIM"
                class="logo-sim"
              />
              <p v-else class="status">
                {{ qualification.status | formatUCStatus }}
              </p>
              <h1 class="title">{{ qualification.consumer_unit }}</h1>
              <p class="address">{{ qualification.address }}</p>
              <button
                class="qualificar_btn"
                @click="qualificarUc(qualification)"
              >
                Qualificar
              </button>
            </div>
          </div>
        </v-flex>
        <!-- <v-flex sm12 md6 v-if="user.bill_links && user.bill_links.length > 0">
            O membro enviou as seguintes contas:
            <v-list>
                <template v-for="(bill, i) in user.bill_links">
                    <v-btn v-bind:key=i color="tertiary" @click="download_bill(bill)">Ver Foto #{{i}}</v-btn>
                </template>
            </v-list>
            </v-flex> -->
      </v-layout>
      <v-layout fluid wrap text-xs-rigth>
        <v-flex sm12 md8>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex
          sm12
          md4
          text-xs-right
          text-md-right
          v-if="!config.searchCemigUcs"
        >
          <v-btn
            class="mx-0 font-weight-light"
            color="secondary"
            dark
            @click="newUC('Manual')"
          >
            <v-icon left dark>add</v-icon>
            Nova Unidade Consumidora
          </v-btn>
        </v-flex>
        <v-flex sm12 md4 text-xs-right text-md-right v-else>
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-0 font-weight-light"
                color="secondary"
                dark
                v-on="on"
              >
                <v-icon left dark>add</v-icon>
                Nova Unidade Consumidora
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                v-for="(item, idx) in addUCList"
                :key="idx"
                @click="newUC(item.title)"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
      <template v-if="loading" v-slot:progress>
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
      </template>
      <v-data-table
        :headers="headers"
        :items="ucs || []"
        item-key="consumer_unit"
        :search="search"
        :loading="loading"
        no-data-text="Não há unidades consumidoras cadastradas"
        rows-per-page-text="Linhas por página"
        :pagination.sync="pagination"
        v-if="ucs"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td>
            <v-icon
              slot="start"
              color="blue"
              v-if="item.person_type && item.person_type.toLowerCase() === 'pf'"
              >roofing</v-icon
            >
            <v-icon
              slot="start"
              color="red"
              v-else-if="
                item.person_type && item.person_type.toLowerCase() === 'pj'
              "
              >store</v-icon
            >
            {{ item.installation_number || "-" }}
          </td>
          <td>
            <v-chip small dark :color="item.status | formatUCStatusColor">{{
              item.status || "-" | formatUCStatus
            }}</v-chip>
          </td>
          <td>{{ item.customer_number || "-" }}</td>
          <td>{{ item.power_plant_id || "-" }}</td>
          <td class="text-xs-right">{{ item.percentage + "%" || "-" }}</td>
          <td>{{ item.plan ? item.plan.name : "Sem Plano" }}</td>
          <td class="text-xs-right">
            {{ item.initial_average_comsumption || "-" }}
          </td>
          <td class="text-xs-right">{{ item.creditos || "-" }}</td>
          <td>
            <v-icon @click.prevent="consumerunitSelected(item)">edit</v-icon>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Sua busca para "{{ search }}" não retornou resultados.
          </v-alert>
        </template>
        <template v-slot:pageText="items">
          Linhas {{ items.pageStart }} - {{ items.pageStop }} de
          {{ items.itemsLength }}
        </template>
      </v-data-table>
    </material-card>
    <v-dialog v-model="autoQualificationDialog" persistent max-width="500px">
      <v-card class="pa-3">
        <v-card-title class="pa-0 pt-2">
          <span class="title font-weight-bold mx-auto"
            >Unidades Consumidoras do Cliente na Cemig</span
          >
        </v-card-title>
        <v-card-text>
          <!-- Código comentado, pois no momento só é possivel qualificar uc do titular na tela membro -->
          <!-- <div class="mx-auto py-0 px-5">
                        <v-flex xs12 md12 class="mx-auto d-flex justify-center">
                            <v-radio-group class="options" v-model="searchPersonType" label=""
                                :rules="[v => !!v || 'Por favor, informe o Tipo de Pessoa!']" row>
                                <v-radio label="Pessoa Física" value="pf"></v-radio>
                                <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-text-field
                            id="customer_cpf"
                            v-model="searchCpf"
                            autofocus
                            :label="searchPersonType === 'pf' ? 'CPF' : 'CNPJ'"
                            :mask="searchPersonType === 'pf' ? '###.###.###-##' : '##.###.###/####-##'"
                            append-outer-icon="autorenew"
                            @click:append-outer="getUcsCemig()"
                            class="px-4"
                            :rules="
                                this.searchPersonType === 'pf'
                                ? [
                                    v => (v && v.length >= 11) || 'Preencha o CPF Completo',
                                    v =>
                                    this.validCPFCNPJ(v) === true || 'CPF inválido'
                                ]
                                : [
                                    v => (v && v.length >= 14) || 'Preencha o CNPJ Completo',
                                    v =>
                                    this.validCPFCNPJ(v) === true ||
                                    'CNPJ inválido'
                                ]
                            "
                        ></v-text-field>
                    </div> -->
          <v-list subheader three-line v-if="ucs_cemig">
            <v-subheader
              >Selecione as unidades consumidoras que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile
              v-for="(uc, idx) in ucs_cemig"
              :key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_checkbox"
                  :value="idx"
                  :color="colors[idx]"
                ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="autoQualificationDialog = false"
              >Fechar</v-btn
            >
            <v-btn
              color="pink darken-1"
              text
              :loading="loading_qualification"
              :disabled="ucs_checkbox?.length == 0 || !ucs_checkbox"
              @click="ucs_selected()"
              >Selecionar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ labelLoading }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-flex>
</template>
<script>
import moment from "moment";
import { eventBus } from "../../main";
import firestore from "../../firebase/firestore";
import { firestorage } from "@/firebase/firestorage";
import { mapMutations, mapActions, mapGetters } from "vuex";
import statesfile from "@/model/state";
import { getCPFCemig } from "../../services/getCPFCemig";
import { mapState } from "vuex";
import { validaCPF, validaCNPJ } from "../../services/users";
import { initQualification } from "../../services/qualification";

export default {
  data: () => ({
    search: "",
    loading: false,
    user: {},
    consumerunit_: {},
    ucs: [],
    headers: [
      // {
      //     sortable: true,
      //     text: 'Atualizado',
      //     value: 'updated_at'
      // },
      {
        sortable: false,
        text: "Unidade Consumidora",
        value: "installation_number",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
      {
        sortable: true,
        text: "Núm. Cliente",
        value: "customer_number",
      },
      {
        sortable: true,
        text: "Planta",
        value: "power_plant_id",
      },
      {
        sortable: true,
        text: "% Planta",
        value: "average",
        align: "right",
      },
      {
        sortable: true,
        text: "Plano",
        value: "plan.name",
      },
      {
        sortable: true,
        text: "Média Consumo (kWh)",
        value: "initial_average_comsumption",
        align: "right",
      },
      {
        sortable: true,
        text: "Créditos",
        value: "creditos",
        align: "right",
      },
      // {
      //     text: '',
      //     sortable: false,
      //     name: 'contas'
      // },
      // {
      //     text: '  ',
      //     sortable: false,
      //     name: 'step'
      // },
      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    pagination: {
      sortBy: "item.updated_at",
      rowsPerPage: 10,
    },
    snack: {
      color: null,
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    },
    addUCList: [{ title: "Manual" }, { title: "Automático" }],
    consumer_unit: {
      cpf: null,
      name: null,
      person_type: null,
      id: "",
      installation_number: "",
      customer_number: "",
      power_plant_id: "",
      percentage: 0,
      percentage_discount: 10,
      fare_amount: 0.95,
      user_id: "",
      label: "",
      rate_class: null,
      sub_class: null,
      average: 0,
      creditos: 0,
      mensalidade: 0,
      economia_mensal: 0,
      economia_anual: 0,
      economia_contrato: 0,
      status: "activated",
      address: {
        address: "",
        address_number: "",
        address_complement: "",
        district: "",
        postal_code: "",
        state: {
          name: "Minas Gerais",
          initials: "MG",
        },
        city: "",
        country: {
          name: "Brasil",
          initials: "BR",
        },
      },
      user: {
        customer_id: "",
        buyer_id: "",
        name: "",
        email: "",
        phone: "",
        cpf: "",
        group: "",
        payment_type: "",
        card_default: "",
        consumer_units: [],
      },
      powerplant: {
        power_plant_id: "",
        name: "",
        power_monthly: "",
      },
      history: [
        { mes_ano: "mês 1", consumo: null, dias: 30 },
        { mes_ano: "mês 2", consumo: null, dias: 30 },
        { mes_ano: "mês 3", consumo: null, dias: 30 },
        { mes_ano: "mês 4", consumo: null, dias: 30 },
      ],
      initial_average_comsumption: "",
    },
    states: statesfile.estados,
    autoQualificationDialog: false,
    loadingDialog: false,
    labelLoading: null,
    ucs_cemig: [],
    ucs_checkbox: [],
    loading_qualification: false,
    colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
    searchCpf: null,
    searchPersonType: "pf",
    showCpfSearch: false,
    qualification_ids: [],
  }),
  async mounted() {
    await this.getUcs();
    await this.getQualifications({
      cpf: this.user?.cpf,
      qualification_ids: this.user?.qualification_ids,
    });
  },
  computed: {
    ...mapState(["config"]),
    ...mapState("qualification", ["qualifications"]),
    ...mapGetters("sales", ["filteredPlans"]),
    ...mapGetters(["loggedUser"]),
    filteredQualifications() {
      return this.qualifications.filter(
        (item) => item.status != "diqualified" && !item.consumer_unit_added,
      );
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object

      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
  methods: {
    ...mapMutations("members", ["setConsumerUnitFormType"]),
    ...mapMutations("qualification", [
      "setAutoQualification",
      "setQualifications",
    ]),
    ...mapActions("qualification", ["getQualifications"]),
    async consumerunitSelected(consumerunit) {
      await this.setConsumerUnitFormType("manual");
      eventBus.$emit("consumerunit", {
        type: "edit",
        data: consumerunit || {},
      });
    },
    async newUC(title) {
      if (title === "Manual") {
        this.consumer_unit.cpf = this.user?.cpf;
        this.consumer_unit.name = this.user?.name;
        this.consumer_unit.person_type = this.user?.person_type;
        this.consumer_unit.type = "new";
        this.setAutoQualification(this.consumer_unit);
        this.$emit("autoQualification", false);
      } else {
        this.showSearchCemigDialog();
      }
    },
    qualificarUc(item) {
      let uc = {};
      if (item.consumer_unit_detail?.address) {
        uc = item?.consumer_unit_detail;
      } else {
        if (item.address) {
          const state_initials = item?.address?.slice(-2);
          const state = this?.states?.filter(
            (item) => item.initials === state_initials,
          )[0];
          const cep = item.address.match(/\b\d{5}-\d{3}\b/)[0];
          const allNumbers = item.address.match(/\d+/g);
          const secondNumber = allNumbers[allNumbers.length - 3];
          const district = item.address
            .match(new RegExp(secondNumber + "(.*?)" + cep, "i"))[1]
            .trim();
          const address_number = item.address.match(/\d+/)[0];
          const address_complement = item.address
            .match(new RegExp(address_number + "(.*?)" + district, "i"))[1]
            .trim();
          const _address = {
            address: item.address.match(/^([A-Z]+\s)+[A-Z]+/)[0],
            address_number: address_number,
            address_complement: address_complement || null,
            district: district || null,
            postal_code: cep,
            state: state || null,
            city: item.address.match(new RegExp(cep + "(.*?),"))[1].trim(),
            country: {
              name: "Brasil",
              initials: "BR",
            },
          };
          uc.address = _address;
        }
      }
      uc.rate_class = uc.rate_class ? uc.rate_class : null;
      uc.sub_class = uc.sub_class ? uc.sub_class : null;
      uc.customer_number = item?.customer_number;
      uc.installation_number = item?.consumer_unit;
      uc.utility_company = uc.utility_company ? uc.utility_company : "cemig";
      if (this.user?.plan) {
        uc.plan = this.user.plan;
      }
      const qualification = {
        cpf: item?.cpf,
        name: item?.name,
        history: [
          { mes_ano: "mês 1", consumo: null, dias: 30 },
          { mes_ano: "mês 2", consumo: null, dias: 30 },
          { mes_ano: "mês 3", consumo: null, dias: 30 },
          { mes_ano: "mês 4", consumo: null, dias: 30 },
        ],
        ...uc,
      };
      if (qualification.cpf?.length > 11) {
        qualification.person_type = "pj";
      } else {
        qualification.person_type = "pf";
      }
      const partner_origin = item?.partner_origin == "SIM" ? true : false;
      const consumer_unit = { ...this.consumer_unit, ...qualification };
      this.setAutoQualification(consumer_unit);
      this.$emit("autoQualification", partner_origin);
    },
    showSearchCemigDialog() {
      this.searchCpf = this.user?.cpf;
      this.searchPersonType = this.user?.person_type;
      this.getUcsCemig();
    },
    closeSearchCemigDialog() {
      this.searchCpf = null;
      this.searchPersonType = null;
      this.autoQualificationDialog = false;
      this.loading_qualification = false;
      this.ucs_checkbox = [];
    },
    async getUcsCemig() {
      this.loadingDialog = true;
      if (this.config.searchCemigUcs && this.searchCpf != "") {
        this.labelLoading = "Buscando dados do membro na CEMIG...";
        await getCPFCemig(this.searchCpf)
          .then((ret) => {
            if (ret.status === 200) {
              this.ucs_cemig = ret.data;
              if (this.ucs_cemig?.length > 0) {
                this.autoQualificationDialog = true;
              } else {
                this.show_snack(
                  "Nenhuma Unidade Consumidora encontrada na CEMIG.",
                  "warning",
                  "top",
                );
              }
              this.loadingDialog = false;
              this.showCpfSearch = false;
            }
          })
          .catch((err) => {
            console.error(err);
            this.show_snack(
              `Erro ao buscar dados na CEMIG. ${
                err?.response ? err.response.data : ""
              }`,
              "warning",
              "top",
            );
            this.loadingDialog = false;
            this.closeSearchCemigDialog();
          });
      } else {
        this.loadingDialog = false;
      }
    },
    async ucs_selected() {
      this.loading_qualification = true;
      const ucs = this.ucs_checkbox.map((index) => this.ucs_cemig[index]);
      const installationNumbers = ucs?.map((uc) => uc.installation_number);
      for (const uc of ucs) {
        const ucFound = (
          await firestore
            .collection("consumer_units")
            .doc(uc.installation_number)
            .get()
        )?.data();

        const statusAllowedToSell = [
          "activated",
          "awaiting_signature",
          "awaiting_contract_generation",
          "canceling",
          "interrupting",
          "interrupted",
        ];

        const uc_status = {
          activated: "Ativo",
          awaiting_signature: "Aguardando assinatura de contrato",
          awaiting_contract_generation: "Aguardando geração de contrato",
          canceling: "Em cancelamento",
          interrupting: "Interrompendo fornecimento",
          interrupted: "Fornecimento interrompido",
        };

        if (statusAllowedToSell.includes(ucFound?.status)) {
          const text = `A UC ${uc.installation_number} já existe com status ${
            uc_status[ucFound.status]
          }.`;
          this.errorOnInitQualification(text, "error");
          return;
        }

        const qualificationFound = this.qualifications.some(
          (item) => item.consumer_unit == uc.installation_number,
        );
        if (qualificationFound) {
          const text = `A UC ${uc.installation_number} já foi adicionada a lista de qualificação.`;
          this.errorOnInitQualification(text, "warning");
          return;
        }
      }
      await initQualification(
        this.searchCpf,
        null,
        installationNumbers,
        "super_manual",
        false,
        null,
        "cemig",
        ucs,
        this.loggedUser?.email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: this.searchCpf,
              qualification_ids: this.qualification_ids,
            };
            this.getQualifications(params);
          }
        })
        .catch((err) => {
          console.error(err);
          this.show_snack(
            `Erro ao iniciar qualificação. ${
              err?.response ? err.response.data : ""
            }`,
            "warning",
            "top",
          );
        });
      this.closeSearchCemigDialog();
    },
    errorOnInitQualification(text, type) {
      this.loading_qualification = false;
      this.dialog_ucs = false;
      this.ucs_checkbox = [];
      this.show_snack(text, type, "top");
    },
    validCPFCNPJ(value) {
      if (this.searchPersonType === "pf") return validaCPF(value);
      else return validaCNPJ(value);
    },
    formatCurrencyEmail(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    // async sendEmail(user, consumerunit) {
    //     this.loading = true
    //     const data_email = {
    //         'email': user.email,
    //         'name': user.name,
    //         'dynamic_template_data': {
    //             'name': user.name,
    //             'email': user.email,
    //             'average': consumerunit.average.toFixed(0),
    //             'custo_disp': consumerunit.custo_disp,
    //             'desvio_padrao': consumerunit.desvio_padrao.toFixed(0),
    //             'creditos': consumerunit.creditos,
    //             'desconto': consumerunit.discount,
    //             'economia_mensal': this.formatCurrencyEmail(consumerunit.economia_mensal),
    //             'economia_total': this.formatCurrencyEmail(consumerunit.economia_contrato),
    //             'email_user': user.email,
    //             'consumer_unit': consumerunit.consumer_unit
    //         },
    //     'template_id': process.env.VUE_APP_SENDGRID_TEMPLATE_PROPOSTA2019,
    //     }
    //     await enviarEmail(data_email)
    //         .then(() => {
    //             this.show_snack('Proposta enviada com sucesso!','success','top')
    //             this.loading = false
    //         })
    //         .catch(error => {
    //             this.show_snack('Erro ao enviar proposta!','error','top')
    //             this.loading = false
    //             console.log(error)
    //         })
    // },
    async getUcs(param) {
      if (this.$route?.params?.id || param) {
        this.ucs = [];
        this.user_id = this.$route?.params?.id || param?.id;
        await firestore
          .collection("users")
          .doc(this.user_id)
          .get()
          .then((ret_doc) => {
            this.user = {
              id: ret_doc.id,
              ...ret_doc.data(),
            };
          })
          .catch((err) => {
            console.error(err);
          });

        firestore
          .collection("consumer_units")
          .where("user_id", "==", this.user_id)
          .onSnapshot({ includeMetadataChanges: true }, (res) => {
            const changes = res.docChanges();
            changes.forEach((change) => {
              const { newIndex, oldIndex, doc, type } = change;
              if (change.type === "added") {
                let new_doc = {
                  ...doc.data(),
                  id: change.doc.id,
                };
                if (!this.ucs?.find((item) => item?.id == new_doc?.id)) {
                  this.ucs.push(new_doc);
                }
                this.loading = false;
              } else if (change.type === "modified") {
                this.ucs.splice(oldIndex, 1);
                let new_doc = {
                  ...change.doc.data(),
                  id: change.doc.id,
                };
                if (this.ucs.length > 0) {
                  this.ucs.splice(newIndex, 0, new_doc);
                } else {
                  this.ucs.push(new_doc);
                }
              } else if (type === "removed") {
                this.ucs.splice(oldIndex, 1);
              }
            });
          });
      }
    },
    async getUcList(param) {
      if (param) {
        this.user = JSON.parse(JSON.stringify(param));
        await this.getUcs(param);
        await this.getQualifications({
          cpf: param?.cpf,
          qualification_ids: param?.qualification_ids,
        });
      } else {
        this.user = {};
        this.ucs = [];
        this.setQualifications([]);
      }
    },
    async download_bill(bill) {
      var photo = firestorage.ref().child(bill.link);
      photo
        .getDownloadURL()
        .then((url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          console.error(error);
          this.show_snack(
            "Erro ao carregar foto. " + error.message_,
            "error",
            "top",
          );
        });
    },
    show_snack(message, color, ...args) {
      this.snack.top = true;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
  },
};
</script>
<style scoped lang="scss">
.options {
  max-width: fit-content !important;
}
.uc_container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  .uc {
    border-radius: 10px;
    padding: 12px;
    border: 2px solid #9e18f7;
    text-align: center;
    max-width: 250px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    .title {
      border-bottom: 3px solid #9e18f7;
      font-size: 16px;
      font-weight: 700 !important;
      margin-bottom: 10px !important;
    }
    p {
      margin: 0;
      margin-bottom: 10px;
    }
    .status {
      color: #000;
      font-weight: 600;
    }
    .qualificar_btn {
      background-color: #9e18f7;
      color: #fff;
      border-radius: 10px;
      margin-top: auto;
      padding: 6px 10px;
      width: 100%;
      font-weight: 700;
      font-size: 14px;
      transition: all 0.4s ease-in-out;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .ucSim {
    border: 2px solid #014c08;
    .logo-sim {
      width: 90px;
      height: 36px;
      margin: 0 auto 10px;
    }
    .title {
      border-bottom: 3px solid #014c08;
    }
    .qualificar_btn {
      background-color: #014c08;
    }
  }
}
</style>
